import React, { useState } from 'react'
import Icon from 'components/Icon'

const CardListRadio = ({ attribute, state, onChange }) => {
  const { key, name, options, disabled, value } = attribute

  return (
    <fieldset className="space-y-2">
      <p className="text-xs font-medium text-gray-600 uppercase tracking-wider">
        { name }
      </p>

      <div className="-space-y-px rounded-sm border border-gray-300 divide-y divide-gray-300">
        { options
          .filter((retakeType) => (value && disabled) ? retakeType.value == value : true)
          .map(({ value, label, description }, i) => (
          <div key={value} className="relative p-4 flex cursor-pointer hover:bg-blue-100" onClick={() => onChange(value)}>
            <div className="flex items-center h-5">
              <input
                type="radio"
                name={`radio-${key}-${i}`}
                className="focus:ring-primary h-4 w-4 text-primary-darker cursor-pointer border-gray-300"
                checked={state == value}
                disabled={disabled}
                value={value}
              />
            </div>

            <label htmlFor={`radio-${key}-${i}`} className="ml-3 flex flex-col cursor-pointer">
              <span className={`${state == value ? 'text-primary' : 'text-gray-900'} block text-sm font-medium`}>
                { label }
              </span>
              <span className={`${state == value ? 'text-primary' : 'text-gray-500'} block text-sm`}>
                { description }
              </span>
            </label>
          </div>
        )) }
      </div>

    </fieldset>
  )
}

export default CardListRadio
